/** Periodicidades das análises de mercado de clientes */
export enum ClienteAnaliseMercadoPeriodicidade {
    ANUAL = 1,
    MEDIA_MENSAL = 2,
    MENSAL = 3
}

/** Valor de uma Periodicidade das análises de mercado de clientes */
export interface ClienteAnaliseMercadoPeriodicidadeValue {
    id: ClienteAnaliseMercadoPeriodicidade;
    nome: string;
}

/** Periodicidade anual */
export const CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL: ClienteAnaliseMercadoPeriodicidadeValue = {
    id: ClienteAnaliseMercadoPeriodicidade.ANUAL,
    nome: 'Anual'
};

/** Periodicidade média mensal */
export const CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL: ClienteAnaliseMercadoPeriodicidadeValue = {
    id: ClienteAnaliseMercadoPeriodicidade.MEDIA_MENSAL,
    nome: 'Média Mensal'
};

/** Periodicidade mensal */
export const CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL: ClienteAnaliseMercadoPeriodicidadeValue = {
    id: ClienteAnaliseMercadoPeriodicidade.MENSAL,
    nome: 'Mensal'
};

/** Periodicidades das Análises de Mercado */
export const CLIENTES_ANALISES_MERCADOS_PERIODICIDADES: ClienteAnaliseMercadoPeriodicidadeValue[] = [
    CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL,
    CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL,
    CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL
];


/** Verifica se a periodicidade da análise de mercado é Anual */
export function isClienteAnaliseMercadoPeriodicidadeAnual(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === CLIENTE_ANALISE_MERCADO_PERIODICIDADE_ANUAL.id;
}


/** Verifica se a periodicidade da análise de mercado é Média Mensal */
export function isClienteAnaliseMercadoPeriodicidadeMediaMensal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MEDIA_MENSAL.id;
}

/** Verifica se a periodicidade da análise de mercado é Mensal */
export function isClienteAnaliseMercadoPeriodicidadeMensal(periodicidade: number): boolean {
    if (!periodicidade) {
        return false;
    }
    return periodicidade === CLIENTE_ANALISE_MERCADO_PERIODICIDADE_MENSAL.id;
}
